import React from "react";

const VideoCall = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_2970_1034"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_2970_1034)">
        <path
          d="M8.15375 13.75H13.8462C14.1039 13.75 14.3189 13.6637 14.4913 13.4913C14.6638 13.3189 14.75 13.1039 14.75 12.8463V10.7693L16.7115 12.7308V7.26925L14.75 9.23075V7.15375C14.75 6.89608 14.6638 6.68108 14.4913 6.50875C14.3189 6.33625 14.1039 6.25 13.8462 6.25H8.15375C7.89608 6.25 7.68108 6.33625 7.50875 6.50875C7.33625 6.68108 7.25 6.89608 7.25 7.15375V12.8463C7.25 13.1039 7.33625 13.3189 7.50875 13.4913C7.68108 13.6637 7.89608 13.75 8.15375 13.75ZM2.5 21.0385V4.30775C2.5 3.80258 2.675 3.375 3.025 3.025C3.375 2.675 3.80258 2.5 4.30775 2.5H19.6923C20.1974 2.5 20.625 2.675 20.975 3.025C21.325 3.375 21.5 3.80258 21.5 4.30775V15.6923C21.5 16.1974 21.325 16.625 20.975 16.975C20.625 17.325 20.1974 17.5 19.6923 17.5H6.0385L2.5 21.0385ZM5.4 16H19.6923C19.7693 16 19.8398 15.9679 19.9038 15.9038C19.9679 15.8398 20 15.7692 20 15.6923V4.30775C20 4.23075 19.9679 4.16025 19.9038 4.09625C19.8398 4.03208 19.7693 4 19.6923 4H4.30775C4.23075 4 4.16025 4.03208 4.09625 4.09625C4.03208 4.16025 4 4.23075 4 4.30775V17.3848L5.4 16Z"
          fill="#1F396C"
        />
      </g>
    </svg>
  );
};

export default VideoCall;
